import { useSync } from '@/app/providers/SyncProvider';
import { Button } from '@/shared/components/Button';
import { Spinner } from '@/shared/components/Spinner';

export function SyncStatusBadge() {
  const { isOnline, isSyncing, lastSuccessAtUtc, lastError, consecutiveFailures, triggerSyncNow } = useSync();

  const style = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 'var(--space-3)',
    padding: 'var(--space-3) var(--space-4)',
    background: 'var(--surface)',
    border: '1px solid var(--border)',
    borderRadius: 'var(--radius-md)',
    marginBottom: 'var(--space-5)',
    fontSize: '0.875rem'
  } as const;

  if (!isOnline) {
    return (
      <div style={style}>
        <span style={{ color: 'var(--text-muted)' }}>Offline — scans will sync automatically once reconnected</span>
      </div>
    );
  }

  if (isSyncing) {
    return (
      <div style={style}>
        <span style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <Spinner label="Syncing" /> Syncing leads…
        </span>
      </div>
    );
  }

  if (consecutiveFailures > 0) {
    return (
      <div style={style}>
        <span style={{ color: 'var(--danger)' }}>{lastError ?? 'Sync is having trouble reaching the server'}</span>
        <Button variant="secondary" onClick={triggerSyncNow} style={{ minHeight: 36, padding: '0 var(--space-3)' }}>
          Retry now
        </Button>
      </div>
    );
  }

  return (
    <div style={style}>
      <span style={{ color: 'var(--success)' }}>
        {lastSuccessAtUtc
          ? `All synced — last at ${new Date(lastSuccessAtUtc).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`
          : 'All synced'}
      </span>
    </div>
  );
}
